import React from 'react';

const AddBagSvg = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" {...props} xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <rect width="30" height="30" fill="#000" rx="15" />
                <path stroke="#FFF" strokeLinecap="round" d="M18.5 8.5h6m-3 3v-6" />
                <g fill="#FFF">
                    <path d="M19.82 12.05 21.09 22H7.86l1.28-9.95h10.68Zm-7.55 2.71a.9.9 0 0 0-.88.9c0 .5.4.91.88.91a.9.9 0 0 0 .88-.9c0-.5-.4-.9-.88-.9Zm4.41 0a.9.9 0 0 0-.88.9c0 .5.4.91.88.91a.9.9 0 0 0 .88-.9c0-.5-.4-.9-.88-.9Z" />
                    <path
                        fillRule="nonzero"
                        d="M14.64 9c1.68 0 3.08 1.09 3.17 2.49v2.6h-1.4v-2.47c0-.73-.78-1.35-1.77-1.35-.94 0-1.7.57-1.75 1.26v2.56h-1.41v-2.47c0-1.47 1.43-2.62 3.16-2.62Z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default AddBagSvg;
